/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useId, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useSelector } from "react-redux";
export default function SidebarComponent() {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;
  const controller = new AbortController();
  const featureMenu = useSelector((state) => state?.featureMenu?.data);
  const divRef = useRef(null); // Ref to access the div
  useEffect(() => {
    return () => {
      controller.abort();
    };
  }, []);

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  const spreadFeaturesInModule = (module) => {
    if ((module?.featureList && module?.featureList?.length)) {
      return (
        <div> {module?.featureList?.map((feature, featureIndex) => {
          return (<Link
          key={`{menu_ ${feature.moduleId} ' ' ${feature.featureId}}`}
            to={feature?.pageUrl || ""}
            className={`nav-link ${isActive(feature?.pageUrl) ? 'active' : ''}`}
          >
            <Icon icon={feature?.icon} className="iconify-size" />
            &nbsp;<p>{feature?.featureName} </p>
          </Link>);
        })
        }
        </div>
      )
    }
  }

  const spreadFeatureMenu = (featureMenuModule, isOuterModule) => {
    // const recursionFunction = spreadFeatureMenu;

    return (
      featureMenuModule?.map((module, index) => {
        return (
          <>
            {
              (isOuterModule)
                ? <>
                  <li className="nav-header text-white">
                    {/* <Icon icon={module?.icon} className="iconify-size" /> */}
                    &nbsp;{module?.moduleName}
                  </li>

                  {(module?.moduleList && module?.moduleList?.length) ? spreadFeatureMenu(module?.moduleList, false) : ""}

                  <div className="card">
                    {spreadFeaturesInModule(module)}
                  </div>
                </>
                : <div className="card">
                  <div className="card-header nav-link" id={`_faqhead${index + 1}`}>
                    <a
                      href="#"
                      className="nav-link collapsed"
                      data-toggle="collapse"
                      data-target={`#_${module?.moduleId}`}
                      aria-expanded={false}
                      aria-controls={`_faqhead${index + 1}`}
                      key={`_faqhead${index + 1}`}
                    >
                      <Icon icon={module?.icon} className="iconify-size" />
                      &nbsp;<p>{module?.moduleName}</p>
                    </a>
                  </div>
                  {
                    <div id={"_" + module?.moduleId} className="collapse" aria-labelledby={`_faqhead${index + 1}`} data-parent="#faq" >
                      <div className="card-body p-0">
                        <ul className="nav nav-treeview" style={{ display: "block" }} key={`_faqhead${index + 1}`}>
                          <div className="card">
                            {spreadFeaturesInModule(module)}
                          </div>
                        </ul>
                      </div>
                    </div>
                  }
                  {(module?.moduleList && module?.moduleList?.length) ? spreadFeatureMenu(module?.moduleList, false) : ""}
                </div>
            }
          </>
        )
      })
    )
  }

  return (
    <>
      <aside
        ref={divRef}
        className="main-sidebar sidebar-dark-primary"
      >
        <Link href="/" className="brand-link">
          <img
            src="./assets/img/assetz-Icon.png"
            alt="AssetZ"
            className="brand-image"

          />
          <span className="brand-text">
            <img
              src="./assets/img/logo-text-assetz.png"
              style={{ position: "relative", top: "0px" }}
              className="img-fluid logo-brand-image"
            />
          </span>
          <span className="version ml-1" style={{ color: '#b98f3b' }}>v {process.env.REACT_APP_VERSION}</span>
        </Link>

        {/* Dynamic Menu */}
        {true
          && 
          <>
            <div style={{ backgroundColor: '#000000', color: 'white', padding: '1.2rem 0rem' }} >
            </div>
            <div className="sidebar">
              <nav>
                <ul
                  className="nav nav-sidebar flex-column"
                  data-widget="treeview"
                  role="menu"
                  data-accordion="false"
                >
                  <div id="main">
                    <div className="accordion" id="faq">
                      {/*<div className="card" style={{ backgroundColor: '#000000', color: 'white', padding:'1.2rem 0rem' }} >
                       <span className="nav-link pt-2 pb-2">
                        <img src="./assets/img/logo-symbol-vishwam.png" alt="VISHWAM" width="30px" className="img-circle p-1" style={{ backgroundColor: '#282C7D ' }} />&nbsp;<p>Go to VISHWAM</p></span> 
                    </div>*/}
                      {spreadFeaturesInModule({ featureList: featureMenu?.featureList })}
                      {spreadFeatureMenu(featureMenu?.moduleList, true)}

                    </div>
                  </div>
                </ul>
              </nav>
            </div>
          </>
        }
        {/* Static Menu */}
        {false
          && <div className="sidebar">
            <nav>
              <ul
                className="nav nav-sidebar flex-column"
                data-widget="treeview"
                role="menu"
                data-accordion="false"
              >
                <div id="main">
                  <div className="accordion" id="faq">
                    <div
                      className="card"
                      style={{ backgroundColor: "#B68E2D", color: "white" }}
                    >
                      <Link
                        to="https://test.vishwamhub.com"
                        className="nav-link p-0"
                        style={{ color: "white" }}
                      >
                        {" "}
                        <span className="nav-link pt-2 pb-2">
                          <img src="./assets/img/logo-symbol-vishwam.png" alt="VISHWAM" width="30px" className="img-circle p-1" style={{ backgroundColor: '#282c7d' }} />
                          &nbsp;<p>Go to VISHWAM</p>
                        </span>
                      </Link>
                    </div>
                    <div className="card">
                      <Link to="/dashboard" className="nav-link"><Icon icon="si:dashboard-line" className="iconify-style" /> <p>Dashboard</p> </Link>
                    </div>
                    <li className="nav-header text-white">MASTER</li>
                    <div className="card">
                      <Link to="/AssetLocation" className="nav-link">
                        <Icon icon="ion:location-outline" className="iconify-style" />
                        <p>Location</p>
                      </Link>
                    </div>
                    <div className="card">
                      <Link to="/OwnerShipType" className="nav-link">
                        <Icon icon="hugeicons:user-list" className="iconify-style" />
                        <p>Ownership Type</p>
                      </Link>
                    </div>

                    <div className="card">
                      <Link to="/AssetStatus" className="nav-link">
                        <Icon icon="ph:list-checks-bold" className="iconify-style" />
                        <p>Status Type</p>
                      </Link>
                    </div>
                    <div className="card">
                      <Link to="/uom" className="nav-link">
                        <Icon icon="hugeicons:tape-measure" className="iconify-style" />
                        <p>UOM</p>
                      </Link>
                    </div>
                    <div className="card">
                      <Link to="/Group" className="nav-link">
                        <Icon icon="lets-icons:group-share" className="iconify-style" />
                        <p>Group</p>
                      </Link>
                    </div>
                    <div className="card">
                      <Link to="/Category" className="nav-link">
                        <Icon icon="bx:category" className="iconify-style" />
                        <p>Category</p>
                      </Link>
                    </div>
                    <div className="card">
                      <Link to="/SubCategory" className="nav-link">
                        <Icon icon="carbon:category-new-each" className="iconify-style" />
                        <p>Sub Category</p>
                      </Link>
                    </div>
                    <div className="card">
                      <Link to="/Specification" className="nav-link">
                        <Icon icon="solar:clipboard-list-linear" className="iconify-style" />
                        <p>Specification</p>
                      </Link>
                    </div>

                    <li className="nav-header text-white">ASSET &amp; LIFECYCLE</li>
                    <div className="card">
                      <Link to="/Asset" className="nav-link">
                        <Icon icon="lets-icons:boxes" className="iconify-style" />
                        <p>Asset</p>
                      </Link>
                    </div>
                    <div className="card">
                      <Link
                        to="/Scrap"
                        className="nav-link">
                        <Icon icon="mingcute:delete-2-line" className="iconify-style" /><p>Scrap</p>
                      </Link>
                    </div>
                    <div className="card">
                      <Link
                        to="/"
                        className="nav-link"><Icon icon="cuida:calendar-outline" className="iconify-style" /><p>AMC</p>
                      </Link>
                    </div>

                    <div className="card">
                      <Link
                        to="/Maint"
                        className="nav-link">
                        <Icon icon="hugeicons:license-maintenance" className="iconify-style" />
                        <p>Maintenance</p>
                      </Link>
                    </div>

                    <div className="card">
                      <Link
                        to="/"
                        className="nav-link"

                      >
                        <Icon icon="cuida:shield-tick-outline" className="iconify-style" /><p>Compliance</p>
                      </Link>
                    </div>


                    <div className="card">
                      <Link
                        to="/Error"
                        className="nav-link"
                      >
                        <Icon icon="akar-icons:schedule" className="iconify-style" />
                        <p>Depreciation Schedule</p>
                      </Link>
                    </div>
                    

                    <div className="card">
                      <Link
                        to="/AssetRequest"
                        className="nav-link"
                      >
                        <Icon icon="akar-icons:schedule" className="iconify-style" />
                        <p> Asset Request  </p>
                      </Link>
                    </div>

                    <div className="card">
                      <Link
                        to="/ApprovedAssetRequest"
                        className="nav-link"
                      >
                        <Icon icon="akar-icons:schedule" className="iconify-style" />
                        <p> Approved Asset Request  </p>
                      </Link>
                    </div>

                    <div className="card">
                      <Link
                        to="/AssetMovement"
                        className="nav-link"
                      >
                        <Icon icon="akar-icons:schedule" className="iconify-style" />
                        <p> Asset Movement  </p>
                      </Link>
                    </div>

                    <div className="card">
                      <Link
                        to="/PendingPRSAP"
                        className="nav-link"
                      >
                        <Icon icon="akar-icons:schedule" className="iconify-style" />
                        <p> Pending PR SAP  </p>
                      </Link>
                    </div>
                    
                  </div>
                </div>
              </ul>
            </nav>
          </div>}

      </aside>
    </>
  );
}
